import { Component, Input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

export type PasswordStrength = 'fraca' | 'media' | 'forte';

@Component({
  selector: 'l-password-feedback',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './password-feedback.component.html',
  styleUrl: './password-feedback.component.scss',
})
export class PasswordFeedbackComponent {

  @Input()
  public password = '';

  @Input()
  public confirmPassword = '';

  public get isPristine(): boolean {
    return !this.password && !this.confirmPassword;
  }

  public get hasMinLength(): boolean {
    return this.password.length >= 6;
  }

  public get passwordsMatch(): boolean {
    return this.password.length > 0 && this.password === this.confirmPassword;
  }

  public get level(): PasswordStrength {
    if (!this.hasMinLength) {
      return 'fraca';
    }

    const variety = [/[a-z]/.test(this.password), /[A-Z]/.test(this.password), /\d/.test(this.password), /[^A-Za-z0-9]/.test(this.password)]
      .filter(Boolean)
      .length;

    if (this.password.length >= 10 || (this.password.length >= 8 && variety >= 2)) {
      return 'forte';
    }

    return 'media';
  }

  public get label(): string {
    if (this.level === 'forte') {
      return 'Forte';
    }

    if (this.level === 'media') {
      return 'Média';
    }

    return 'Fraca';
  }

  public readonly segments = [1, 2, 3];

  public get filledCount(): number {
    if (!this.password) {
      return 0;
    }

    if (this.level === 'forte') {
      return 3;
    }

    if (this.level === 'media') {
      return 2;
    }

    return 1;
  }

}
